var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 86.374 86.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13306",
    d: "M19.8 6a10.554 10.554 0 0 0-8.088 3.457A11.05 11.05 0 0 0 9 16.8c0 4.513 2.642 7.63 4.36 9.657l.092.108c2.029 2.4 2.746 3.406 2.746 4.63a3.6 3.6 0 1 0 7.2 0c0-4.08-2.534-7.04-4.143-8.921l-.308-.361C17.059 19.684 16.2 18.421 16.2 16.8a3.865 3.865 0 0 1 .89-2.558A3.388 3.388 0 0 1 19.8 13.2a3.388 3.388 0 0 1 2.709 1.041A3.865 3.865 0 0 1 23.4 16.8a3.6 3.6 0 1 0 7.2 0 11.051 11.051 0 0 0-2.709-7.34A10.554 10.554 0 0 0 19.8 6z",
    transform: "translate(23.39 15.594)",
    style: {
      fill: "#6610f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13307",
    d: "M14.6 15a3.6 3.6 0 1 0 3.6 3.6 3.6 3.6 0 0 0-3.6-3.6z",
    transform: "translate(28.588 38.984)",
    style: {
      fill: "#6610f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13308",
    d: "M0 43.188c0 35.565 7.623 43.187 43.187 43.187s43.187-7.623 43.187-43.188S78.751 0 43.187 0 0 7.623 0 43.188zm7.2 0c0 8.727.477 15.248 1.575 20.191 1.08 4.86 2.663 7.74 4.573 9.65S18.137 76.522 23 77.6c4.942 1.1 11.463 1.575 20.19 1.575S58.435 78.7 63.377 77.6c4.86-1.08 7.74-2.663 9.65-4.574s3.493-4.79 4.574-9.65c1.1-4.942 1.575-11.463 1.575-20.191S78.7 27.939 77.6 23c-1.08-4.86-2.663-7.74-4.574-9.651s-4.79-3.493-9.65-4.573C58.435 7.675 51.914 7.2 43.187 7.2S27.939 7.675 23 8.773c-4.86 1.08-7.74 2.663-9.65 4.573S9.853 18.137 8.773 23C7.675 27.939 7.2 34.461 7.2 43.188z",
    style: {
      fill: "#abafd1",
      fillRule: "evenodd"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.633d6097d8da8f8ba85a28871171ec53.svg";
export { ForwardRef as ReactComponent };